(function (window, document) {
  'use strict';

  var GUIDE_VERSION = 'custom-text-v1';
  var MAX_TEXT_LENGTH = 20;
  var MIN_TEXT_LENGTH = 2;
  /*
   * The printable charset. Mirrors TEXT_CHARACTER_CLASS in
   * skills/Supplier-Order-Router/text_overlay.py character for character:
   * ASCII letters, digits, space, the sold symbols, and every accented Latin
   * letter all five fonts carry (Latin-1 + Latin Extended-A minus the rare
   * letters Cinzel or Style Script lack). No emoji.
   */
  var TEXT_CHARACTER_CLASS =
    "A-Za-z0-9 '\\-.&!" +
    "@#$%?,:;()+/*\"\\u20ac\\u00a3\\u00a9\\u00ae\\u2122\\u2018\\u2019\\u201c\\u201d" +
    "\\u00c0-\\u00d6\\u00d8-\\u00f6\\u00f8-\\u0107\\u010a-\\u0113\\u0116-\\u011b" +
    "\\u011e-\\u0123\\u0126-\\u0127\\u012a-\\u012b\\u012e-\\u0131\\u0136-\\u0137" +
    "\\u0139-\\u013e\\u0141-\\u0148\\u014a-\\u014d\\u0150-\\u015b\\u015e-\\u0167" +
    "\\u016a-\\u016b\\u016e-\\u017e";
  var ALLOWED_TEXT_PATTERN = new RegExp('^[' + TEXT_CHARACTER_CLASS + ']*$');
  var DISALLOWED_CHARACTERS = new RegExp('[^' + TEXT_CHARACTER_CLASS + ']', 'g');

  /*
   * The printed inset is EXACTLY 25 mm from each mat edge. As a CSS percent of
   * the mat dimension that is (25 / dimension_mm) * 100 = 2500 / dimension_mm.
   */
  var INSET_PERCENT_NUMERATOR = 2500;

  /* Shrink-to-fit: the rendered text may use at most 58% of the frame width. */
  var MAX_TEXT_WIDTH_RATIO = 0.58;

  var OPTION_NAME = 'Personalization';
  var OPTION_VALUE_NONE = 'None';
  var OPTION_VALUE_CUSTOM = 'Custom text';

  /*
   * mmEm is the cap-to-cap visual size of one em expressed in mat millimetres
   * at the Medium setting. Screen px = mmEm * (frame_px / mat_width_mm).
   */
  var FONT_PROFILES = {
    'style-script': { label: 'Style Script', family: "'Style Script', cursive", weight: 400, mmEm: 28 },
    'great-vibes': { label: 'Great Vibes', family: "'Great Vibes', cursive", weight: 400, mmEm: 27 },
    'bebas-neue': { label: 'Bebas Neue', family: "'Bebas Neue', sans-serif", weight: 400, mmEm: 20 },
    'montserrat': { label: 'Montserrat', family: "'Montserrat', sans-serif", weight: 600, mmEm: 15 },
    'cinzel': { label: 'Cinzel', family: "'Cinzel', serif", weight: 600, mmEm: 15.5 }
  };

  var SIZE_MULTIPLIERS = { small: 0.72, medium: 1, large: 1.45 };

  var CORNER_LABELS = {
    'top-left': 'Top left',
    'top-right': 'Top right',
    'bottom-left': 'Bottom left',
    'bottom-right': 'Bottom right'
  };

  /*
   * Visible (no leading underscore) line-item properties. The hidden inputs
   * live inside the purchase form and stay disabled while Personalization is
   * "None" so no empty properties leak into the cart.
   */
  var PROPERTY_INPUT_NAMES = {
    custom_text: 'properties[custom_text]',
    custom_font: 'properties[custom_font]',
    custom_corner: 'properties[custom_corner]',
    custom_color: 'properties[custom_color]',
    custom_size: 'properties[custom_size]'
  };

  var FALLBACK_MAT = { widthMm: 800, heightMm: 300, label: 'selected size' };

  /*
   * An RGB mat (SKU RGB-<design>-WxHx4 or CustomRGB-…, or the "RGB" value of
   * the Type option) has its controller at the top of the left edge, so text
   * is never offered there; the supplier export holds such an order anyway.
   */
  var RGB_BLOCKED_CORNER = 'top-left';
  var RGB_FALLBACK_CORNER = 'bottom-left';

  function isRgbVariant(variant) {
    if (!variant) return false;
    if (/^(CUSTOMRGB|RGB-)/i.test(String(variant.sku || ''))) return true;
    var options = variant.options || [];
    for (var index = 0; index < options.length; index += 1) {
      if (String(options[index]) === 'RGB') return true;
    }
    return false;
  }

  function isPurchaseForm(form) {
    if (!form || form.classList.contains('js-instalments-form')) return false;
    if (form.classList.contains('js-product-form')) return true;
    return Boolean(form.querySelector(
      '[name="add"], button[type="submit"], input[type="submit"]'
    ));
  }

  function purchaseFormIn(scope) {
    if (!scope) return null;
    var forms = scope.querySelectorAll('form[action*="/cart/add"]');
    for (var index = 0; index < forms.length; index += 1) {
      if (isPurchaseForm(forms[index])) return forms[index];
    }
    return null;
  }

  function purchaseFormsFor(panel) {
    var scope = panel.parentElement &&
      panel.parentElement.closest('.product-form, .product__info-container, [data-product-id]');
    var roots = scope ? [scope, document] : [document];
    for (var rootIndex = 0; rootIndex < roots.length; rootIndex += 1) {
      var forms = roots[rootIndex].querySelectorAll('form[action*="/cart/add"]');
      var candidates = [];
      for (var index = 0; index < forms.length; index += 1) {
        if (isPurchaseForm(forms[index])) candidates.push(forms[index]);
      }
      if (candidates.length) return candidates;
    }
    return [];
  }

  /*
   * Symmetry renders more than one purchase form for the same product (the
   * main form plus the sticky add-to-cart bar's copy). The MAIN form hosts
   * the panel and drives variant switches; every purchase form receives the
   * property inputs so a sticky-bar add-to-cart still carries the text.
   */
  function primaryPurchaseForm(candidates) {
    if (candidates.length < 2) return candidates[0] || null;
    var main = [];
    for (var index = 0; index < candidates.length; index += 1) {
      var form = candidates[index];
      if (
        !form.closest(
          '.sticky-atc, [class*="sticky-atc"], [data-sticky-atc], ' +
          '.quick-buy, [class*="quickbuy"], [class*="quick-buy"], ' +
          'dialog, [role="dialog"]'
        )
      ) {
        main.push(form);
      }
    }
    return (main.length ? main : candidates)[0];
  }

  function findProductForm(panel) {
    return primaryPurchaseForm(purchaseFormsFor(panel));
  }

  function selectedVariantId(form) {
    if (!form) return '';
    var input = form.querySelector('[name="id"]');
    return input && input.value ? String(input.value) : '';
  }

  function readConfig(panel) {
    var productId = panel.getAttribute('data-product-id');
    var script = document.querySelector(
      'script[data-epic-custom-text-config="' + productId + '"]'
    );
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      if (window.console && typeof window.console.error === 'function') {
        window.console.error('[Epic custom text] Product configuration did not parse.', error);
      }
      return null;
    }
  }

  function personalizationOptionIndex(config) {
    var names = (config && config.optionNames) || [];
    for (var index = 0; index < names.length; index += 1) {
      if (String(names[index]).trim().toLowerCase() === OPTION_NAME.toLowerCase()) return index;
    }
    return -1;
  }

  function hasCustomTextVariant(config, optionIndex) {
    var variants = (config && config.variants) || [];
    for (var index = 0; index < variants.length; index += 1) {
      var options = variants[index].options || [];
      if (String(options[optionIndex]) === OPTION_VALUE_CUSTOM) return true;
    }
    return false;
  }

  function findVariantById(config, variantId) {
    var variants = (config && config.variants) || [];
    for (var index = 0; index < variants.length; index += 1) {
      if (String(variants[index].id) === String(variantId)) return variants[index];
    }
    return null;
  }

  function siblingVariant(config, optionIndex, baseVariant, targetValue) {
    if (!baseVariant) return null;
    var variants = (config && config.variants) || [];
    for (var index = 0; index < variants.length; index += 1) {
      var candidate = variants[index];
      var matches = true;
      var options = candidate.options || [];
      var baseOptions = baseVariant.options || [];
      for (var position = 0; position < options.length; position += 1) {
        if (position === optionIndex) {
          if (String(options[position]) !== targetValue) matches = false;
        } else if (String(options[position]) !== String(baseOptions[position])) {
          matches = false;
        }
      }
      if (matches) return candidate;
    }
    return null;
  }

  /*
   * Mat millimetres come from the variant SKU "design-WxHxT" first, then from
   * any option label such as "90x40" or "90 × 40 cm". Values at or below
   * 200 are centimetres and are converted to millimetres.
   */
  function parseMatMm(variant) {
    if (!variant) return null;
    var candidates = [];
    if (variant.sku) candidates.push(String(variant.sku));
    var options = variant.options || [];
    for (var index = 0; index < options.length; index += 1) candidates.push(String(options[index]));
    if (variant.title) candidates.push(String(variant.title));

    for (var position = 0; position < candidates.length; position += 1) {
      var match = candidates[position]
        .replace(/×/g, 'x')
        .match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
      if (!match) continue;
      var width = Number(match[1]);
      var height = Number(match[2]);
      if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) continue;
      if (width <= 200) width *= 10;
      if (height <= 200) height *= 10;
      return {
        widthMm: width,
        heightMm: height,
        label: (width / 10) + ' × ' + (height / 10) + ' cm'
      };
    }
    return null;
  }

  /*
   * The fee label must follow Shopify Markets: each variant is rounded
   * per currency, so the real fee is the localized price gap between the
   * selected size's "Custom text" variant and its "None" sibling — never
   * a hardcoded store-currency number. Liquid emits prices in minor
   * units (all live markets use 2-decimal currencies; a zero-decimal
   * currency would need a divisor map here).
   */
  function formatMinorUnits(amount, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency
      }).format(amount / 100);
    } catch (error) {
      return '$' + (amount / 100).toFixed(2);
    }
  }

  function updateFeeLabel(panel, form, config) {
    var label = panel.querySelector('[data-epic-text-fee]');
    if (!label) return;
    if (config.freeMode === true) {
      /* Free mode: variants are repriced to a zero delta, so no computed
         amount exists to show — a currency-safe badge only. */
      label.textContent = 'FREE';
      label.classList.add('epic-custom-text__price--free');
      return;
    }
    label.classList.remove('epic-custom-text__price--free');
    var optionIndex = panel.__epicCustomTextOptionIndex;
    var current = findVariantById(config, selectedVariantId(form)) ||
      (config.variants || [])[0];
    if (!current) { label.textContent = ''; return; }
    var none = String((current.options || [])[optionIndex]) === OPTION_VALUE_NONE
      ? current
      : siblingVariant(config, optionIndex, current, OPTION_VALUE_NONE);
    var custom = siblingVariant(config, optionIndex, none || current, OPTION_VALUE_CUSTOM);
    if (
      !none || !custom ||
      typeof none.price !== 'number' || typeof custom.price !== 'number' ||
      !(custom.price > none.price)
    ) {
      /* Never show a wrong number: no data, no label. */
      label.textContent = '';
      return;
    }
    label.textContent = '+' + formatMinorUnits(
      custom.price - none.price, config.currency || 'USD'
    );
  }

  function ensurePropertyInput(form, name) {
    var input = form.querySelector('input[data-epic-custom-text-property="' + name + '"]');
    if (input) return input;
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = PROPERTY_INPUT_NAMES[name];
    input.setAttribute('data-epic-custom-text-property', name);
    input.disabled = true;
    form.appendChild(input);
    return input;
  }

  function markScope(panel) {
    var scope = panel.parentElement &&
      panel.parentElement.closest('.product-form, .product__info-container, [data-product-id]');
    if (scope) scope.classList.add('epic-custom-text-scope');
    var form = findProductForm(panel);
    if (form) form.classList.add('epic-custom-text-scope');
  }

  function disableExpressCheckout(panel) {
    var scope = panel.parentElement &&
      panel.parentElement.closest('.product-form, .product__info-container, [data-product-id]');
    if (!scope) return;
    var buttons = scope.querySelectorAll(
      '.shopify-payment-button, [data-shopify="payment-button"], [data-testid="Checkout-button"]'
    );
    for (var index = 0; index < buttons.length; index += 1) {
      buttons[index].hidden = true;
      buttons[index].setAttribute('aria-hidden', 'true');
      buttons[index].setAttribute('data-epic-custom-text-disabled', 'true');
    }
  }

  function placePanelInForm(panel, form) {
    if (!form || form.contains(panel)) return;
    var submit = form.querySelector('[name="add"], button[type="submit"], input[type="submit"]');
    var anchor = submit;
    while (anchor && anchor.parentElement && anchor.parentElement !== form) anchor = anchor.parentElement;
    if (anchor && anchor.parentElement === form) {
      form.insertBefore(panel, anchor);
    } else {
      form.appendChild(panel);
    }
  }

  /*
   * The catalog's second option renders its own theme picker row. Ours
   * replaces it, so hide the theme row whose control offers exactly the
   * None / Custom text values. Defensive: if nothing matches, both controls
   * stay usable and remain in sync through the variant events.
   */
  function hideThemePersonalizationPicker(panel) {
    /* Document-wide on purpose: the panel itself carries data-product-id,
       so a closest() scope collapses onto the panel and never sees the
       theme's picker (Symmetry renders it outside the purchase form).
       Every pass below already excludes anything inside the panel. */
    var scope = document;
    var selects = scope.querySelectorAll('select');
    for (var index = 0; index < selects.length; index += 1) {
      var values = [];
      for (var option = 0; option < selects[index].options.length; option += 1) {
        values.push(selects[index].options[option].value || selects[index].options[option].text);
      }
      if (values.indexOf(OPTION_VALUE_CUSTOM) !== -1 && values.indexOf(OPTION_VALUE_NONE) !== -1) {
        var wrapper = selects[index].closest(
          '.selector-wrapper, .option-selector, .variant-wrapper, fieldset, [data-selector-type]'
        ) || selects[index];
        if (!wrapper.contains(panel)) {
          wrapper.hidden = true;
          wrapper.setAttribute('data-epic-custom-text-hidden-picker', 'true');
        }
      }
    }
    var radios = scope.querySelectorAll(
      'input[type="radio"][value="' + OPTION_VALUE_CUSTOM + '"]'
    );
    for (var radioIndex = 0; radioIndex < radios.length; radioIndex += 1) {
      if (radios[radioIndex].name === 'epic_text_choice') continue;
      var radioWrapper = radios[radioIndex].closest(
        '.selector-wrapper, .option-selector, .variant-wrapper, fieldset'
      );
      if (radioWrapper && !radioWrapper.contains(panel)) {
        radioWrapper.hidden = true;
        radioWrapper.setAttribute('data-epic-custom-text-hidden-picker', 'true');
      }
    }

    /* Symmetry's "listed" picker: fieldset.option-selector with
       label > span.js-value pills. Match by the option's value texts. */
    var groups = scope.querySelectorAll(
      'fieldset, .option-selector, .selector-wrapper'
    );
    for (var groupIndex = 0; groupIndex < groups.length; groupIndex += 1) {
      var group = groups[groupIndex];
      if (group.contains(panel) || group.hidden) continue;
      var valueEls = group.querySelectorAll('.js-value, [data-option-value]');
      var seenCustom = false;
      var seenNone = false;
      for (var valueIndex = 0; valueIndex < valueEls.length; valueIndex += 1) {
        var text = (valueEls[valueIndex].textContent || '').trim();
        if (text === OPTION_VALUE_CUSTOM) seenCustom = true;
        else if (text === OPTION_VALUE_NONE) seenNone = true;
      }
      if (seenCustom && seenNone) {
        group.hidden = true;
        group.setAttribute('data-epic-custom-text-hidden-picker', 'true');
      }
    }
  }

  function driveVariant(panel, form, variant) {
    if (!form || !variant) return;
    var scope = form.closest('.product-form, .product__info-container, [data-product-id]') || form;
    var optionIndexForLabels = panel.__epicCustomTextOptionIndex;
    var labelTarget = (variant.options || [])[optionIndexForLabels];

    /* Symmetry's "listed" picker first: click the pill label whose
       span.js-value matches, so the theme updates price/URL/availability
       through its own machinery even while the row is hidden. Search the
       whole document — the picker lives outside the purchase form. */
    var pickerLabels = document.querySelectorAll(
      'fieldset label, .option-selector label'
    );
    for (var labelIndex = 0; labelIndex < pickerLabels.length; labelIndex += 1) {
      var label = pickerLabels[labelIndex];
      if (label.closest('[data-epic-custom-text]')) continue;
      var valueEl = label.querySelector('.js-value');
      if (!valueEl) continue;
      var group = label.closest('fieldset, .option-selector');
      if (!group) continue;
      var groupValues = group.querySelectorAll('.js-value');
      var groupHasCustom = false;
      for (var gv = 0; gv < groupValues.length; gv += 1) {
        if ((groupValues[gv].textContent || '').trim() === OPTION_VALUE_CUSTOM) {
          groupHasCustom = true;
          break;
        }
      }
      if (!groupHasCustom) continue;
      if ((valueEl.textContent || '').trim() === labelTarget) {
        var control = label.querySelector('input');
        if (!control || !control.checked) label.click();
        return;
      }
    }

    /* Prefer the theme's own (possibly hidden) selector so Symmetry updates
       price, availability, and URL itself. */
    var selects = scope.querySelectorAll('select');
    var optionIndex = panel.__epicCustomTextOptionIndex;
    var target = (variant.options || [])[optionIndex];
    for (var index = 0; index < selects.length; index += 1) {
      var select = selects[index];
      var values = [];
      for (var option = 0; option < select.options.length; option += 1) {
        values.push(select.options[option].value || select.options[option].text);
      }
      if (values.indexOf(OPTION_VALUE_CUSTOM) !== -1 && values.indexOf(OPTION_VALUE_NONE) !== -1) {
        if (select.value !== target) {
          select.value = target;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
    }

    var radios = scope.querySelectorAll('input[type="radio"][value="' + target + '"]');
    for (var radioIndex = 0; radioIndex < radios.length; radioIndex += 1) {
      if (radios[radioIndex].name === 'epic_text_choice') continue;
      if (!radios[radioIndex].checked) {
        radios[radioIndex].checked = true;
        radios[radioIndex].dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    /* Fallback: set the master variant input directly. */
    var idInput = form.querySelector('[name="id"]');
    if (idInput && String(idInput.value) !== String(variant.id)) {
      idInput.value = String(variant.id);
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function filteredText(rawValue) {
    var value = String(rawValue || '');
    /* NFC first: a decomposed "e" + combining accent becomes one "é". */
    var composed = value.normalize ? value.normalize('NFC') : value;
    var cleaned = composed.replace(DISALLOWED_CHARACTERS, '').slice(0, MAX_TEXT_LENGTH);
    return { value: cleaned, removed: cleaned !== composed };
  }

  function textIsValid(value) {
    var trimmed = String(value || '').trim();
    return ALLOWED_TEXT_PATTERN.test(trimmed) &&
      trimmed.length >= MIN_TEXT_LENGTH &&
      trimmed.length <= MAX_TEXT_LENGTH;
  }

  function panelState(panel) {
    var state = panel.__epicCustomTextState;
    if (state) return state;
    state = {
      font: 'style-script',
      size: 'medium',
      color: 'White',
      corner: 'bottom-left',
      text: '',
      mat: FALLBACK_MAT
    };
    panel.__epicCustomTextState = state;
    return state;
  }

  function setPressed(panel, selector, attribute, activeValue) {
    var buttons = panel.querySelectorAll(selector);
    for (var index = 0; index < buttons.length; index += 1) {
      var isActive = buttons[index].getAttribute(attribute) === activeValue;
      buttons[index].setAttribute('aria-pressed', isActive ? 'true' : 'false');
      buttons[index].classList.toggle('epic-custom-text__chip--active', isActive);
      buttons[index].classList.toggle('epic-custom-text__corner--active', isActive);
      buttons[index].classList.toggle('epic-custom-text__swatch--active', isActive);
    }
  }

  /*
   * Designs before 01964 do not print from one centered crop. Each size
   * prints from whichever file the router resolves — a generative-expand
   * `_8_3` / `_2_1` file, a coverage master, or the plain base that the
   * print step STRETCHES to the mat. `digital.text_preview_map` (written by
   * scripts/mint_text_preview_assets.py --legacy-map from the router's own
   * resolver) names, per size, the image to show and how to shape it:
   * "cover" = centered crop, "fill" = stretch. No map = the 01964+ contract:
   * one asset, centered crop.
   */
  function usablePreviewMap(rawMap) {
    if (!rawMap || typeof rawMap !== 'object' || rawMap.v !== 1) return null;
    if (!rawMap.sizes || typeof rawMap.sizes !== 'object') return null;
    return rawMap;
  }

  function previewEntryFor(state) {
    if (!state.previewMap) return { ok: true, src: '', fit: 'cover' };
    var mat = state.mat || FALLBACK_MAT;
    var entry = state.previewMap.sizes[mat.widthMm + 'x' + mat.heightMm];
    if (
      !entry ||
      typeof entry.src !== 'string' ||
      entry.src.indexOf('https://') !== 0 ||
      (entry.fit !== 'cover' && entry.fit !== 'fill')
    ) {
      /* Fail closed: never show a preview that is not this size's print. */
      return { ok: false, src: '', fit: 'cover' };
    }
    return { ok: true, src: entry.src, fit: entry.fit };
  }

  function applyPreviewImage(panel, state) {
    var entry = previewEntryFor(state);
    state.previewOk = entry.ok;
    var image = panel.querySelector('[data-epic-text-preview-img]');
    if (!image) return;
    image.style.objectFit = entry.fit;
    image.style.visibility = entry.ok ? '' : 'hidden';
    if (entry.src && image.getAttribute('src') !== entry.src) {
      image.setAttribute('src', entry.src);
    }
  }

  function updatePreview(panel) {
    var state = panelState(panel);
    applyPreviewImage(panel, state);
    var frame = panel.querySelector('[data-epic-text-frame]');
    var overlay = panel.querySelector('[data-epic-text-overlay]');
    if (!frame || !overlay) return;

    var mat = state.mat || FALLBACK_MAT;
    var ratio = mat.widthMm + ' / ' + mat.heightMm;
    frame.style.aspectRatio = ratio;
    var picker = panel.querySelector('[data-epic-text-corner-picker]');
    if (picker) picker.style.aspectRatio = ratio;

    var sizeLabel = panel.querySelector('[data-epic-text-size-label]');
    if (sizeLabel) sizeLabel.textContent = mat.label;

    var profile = FONT_PROFILES[state.font] || FONT_PROFILES['style-script'];
    overlay.textContent = state.text.trim();
    overlay.style.fontFamily = profile.family;
    overlay.style.fontWeight = String(profile.weight);
    overlay.classList.toggle('epic-custom-text__overlay--white', state.color === 'White');
    overlay.classList.toggle('epic-custom-text__overlay--black', state.color === 'Black');

    var insetX = (INSET_PERCENT_NUMERATOR / mat.widthMm) + '%';
    var insetY = (INSET_PERCENT_NUMERATOR / mat.heightMm) + '%';
    overlay.style.top = state.corner.indexOf('top') === 0 ? insetY : 'auto';
    overlay.style.bottom = state.corner.indexOf('bottom') === 0 ? insetY : 'auto';
    overlay.style.left = state.corner.indexOf('left', 1) !== -1 ? insetX : 'auto';
    overlay.style.right = state.corner.indexOf('right', 1) !== -1 ? insetX : 'auto';

    var frameWidth = frame.getBoundingClientRect().width;
    if (!frameWidth) return;
    var multiplier = SIZE_MULTIPLIERS[state.size] || 1;
    var fontSize = profile.mmEm * (frameWidth / mat.widthMm) * multiplier;
    overlay.style.fontSize = fontSize + 'px';

    /* Shrink-to-fit when the line would exceed 58% of the frame width. */
    var overlayWidth = overlay.getBoundingClientRect().width;
    var maxWidth = frameWidth * MAX_TEXT_WIDTH_RATIO;
    if (overlayWidth > maxWidth && overlayWidth > 0) {
      overlay.style.fontSize = (fontSize * maxWidth / overlayWidth) + 'px';
    }
  }

  function syncProperties(panel, form) {
    if (!form) return;
    var state = panelState(panel);
    var personalized = panel.getAttribute('data-epic-text-personalized') === 'true';
    var profile = FONT_PROFILES[state.font] || FONT_PROFILES['style-script'];
    var values = {
      custom_text: state.text.trim(),
      custom_font: profile.label,
      custom_corner: state.corner,
      custom_color: state.color,
      custom_size: state.size.charAt(0).toUpperCase() + state.size.slice(1)
    };
    var forms = panel.__epicCustomTextForms || [form];
    for (var formIndex = 0; formIndex < forms.length; formIndex += 1) {
      for (var name in PROPERTY_INPUT_NAMES) {
        if (!Object.prototype.hasOwnProperty.call(PROPERTY_INPUT_NAMES, name)) continue;
        var input = ensurePropertyInput(forms[formIndex], name);
        input.value = values[name];
        input.disabled = !personalized;
      }
    }
  }

  function updateValidation(panel, form) {
    var state = panelState(panel);
    var personalized = panel.getAttribute('data-epic-text-personalized') === 'true';
    var confirm = panel.querySelector('[data-epic-text-confirm]');
    var confirmed = Boolean(confirm && confirm.checked);
    var previewOk = state.previewOk !== false;
    var valid = textIsValid(state.text) && previewOk;
    panel.setAttribute('data-epic-text-valid', valid ? 'true' : 'false');
    panel.setAttribute('data-epic-text-confirmed', confirmed ? 'true' : 'false');

    var reason = panel.querySelector('[data-epic-text-reason]');
    if (reason) {
      if (!personalized) {
        reason.textContent = '';
      } else if (!previewOk) {
        reason.textContent = 'Custom text is not available for this size yet — please choose another size.';
      } else if (!valid) {
        reason.textContent = 'Add ' + MIN_TEXT_LENGTH + '–' + MAX_TEXT_LENGTH +
          ' printable characters to continue.';
      } else if (!confirmed) {
        reason.textContent = 'Tick the confirmation box to enable Add to cart.';
      } else {
        reason.textContent = 'Personalization ready — the same text is printed on every mat in this quantity.';
      }
    }
    if (valid && confirmed) {
      var error = panel.querySelector('[data-epic-text-error]');
      if (error) error.hidden = true;
      panel.classList.remove('epic-custom-text--blocked');
    }
    syncProperties(panel, form);
  }

  function setPersonalized(panel, form, config, personalized, options) {
    var settings = options || {};
    panel.setAttribute('data-epic-text-personalized', personalized ? 'true' : 'false');
    var panelBody = panel.querySelector('[data-epic-text-panel]');
    if (panelBody) panelBody.hidden = !personalized;
    var noneRadio = panel.querySelector('[data-epic-text-choice-none]');
    var customRadio = panel.querySelector('[data-epic-text-choice-custom]');
    if (noneRadio) noneRadio.checked = !personalized;
    if (customRadio) customRadio.checked = personalized;

    if (!settings.fromVariant && form) {
      var optionIndex = panel.__epicCustomTextOptionIndex;
      var current = findVariantById(config, selectedVariantId(form));
      var target = siblingVariant(
        config,
        optionIndex,
        current,
        personalized ? OPTION_VALUE_CUSTOM : OPTION_VALUE_NONE
      );
      if (target) {
        driveVariant(panel, form, target);
      } else if (current) {
        /* No variant pairs this choice with the selected size and type:
           stay on what is actually selected rather than writing text
           properties onto a plain mat. */
        var actual = String((current.options || [])[optionIndex]) === OPTION_VALUE_CUSTOM;
        if (actual !== personalized) {
          setPersonalized(panel, form, config, actual, { fromVariant: true });
          return;
        }
      }
    }
    if (personalized) updatePreview(panel);
    updateValidation(panel, form);
  }

  function applyRgbCornerRule(panel, form, variant) {
    var rgb = isRgbVariant(variant);
    panel.setAttribute('data-epic-text-rgb', rgb ? 'true' : 'false');
    var choices = panel.querySelectorAll('[data-epic-text-corner-choice="' + RGB_BLOCKED_CORNER + '"]');
    for (var index = 0; index < choices.length; index += 1) {
      choices[index].disabled = rgb;
      if (rgb) {
        choices[index].setAttribute('title', 'The RGB controller sits here');
      } else {
        choices[index].removeAttribute('title');
      }
    }
    if (rgb && panelState(panel).corner === RGB_BLOCKED_CORNER) {
      setCorner(panel, form, RGB_FALLBACK_CORNER);
    }
  }

  function applySelectedVariant(panel, form, config, reason) {
    if (!form) return;
    var optionIndex = panel.__epicCustomTextOptionIndex;
    var variant = findVariantById(config, selectedVariantId(form));
    var state = panelState(panel);
    var mat = parseMatMm(variant);

    /* Fall back to the sibling "None" variant's size when a variant is
       missing, then to the flat 8:3 preview shape. */
    if (!mat) mat = FALLBACK_MAT;
    state.mat = mat;

    if (variant) {
      var personalized = String((variant.options || [])[optionIndex]) === OPTION_VALUE_CUSTOM;
      if ((panel.getAttribute('data-epic-text-personalized') === 'true') !== personalized) {
        setPersonalized(panel, form, config, personalized, { fromVariant: true });
      }
    }
    applyRgbCornerRule(panel, form, variant);
    updatePreview(panel);
    updateValidation(panel, form);
    updateFeeLabel(panel, form, config);
    if (reason === 'variant-change') hideThemePersonalizationPicker(panel);
  }

  function bindVariantChanges(panel, form, config) {
    if (!form || form.__epicCustomTextVariantEventsBound) return;
    form.__epicCustomTextVariantEventsBound = true;
    var schedule = function () {
      window.setTimeout(function () {
        applySelectedVariant(panel, form, config, 'variant-change');
      }, 0);
      window.setTimeout(function () {
        applySelectedVariant(panel, form, config, 'variant-change');
      }, 120);
    };
    form.addEventListener('change', schedule, true);
    form.addEventListener('click', function (event) {
      if (
        event.target &&
        event.target.closest &&
        event.target.closest('input[type="radio"], [data-option-value], [data-variant-id]')
      ) {
        schedule();
      }
    }, true);
  }

  function bindControls(panel, form, config) {
    if (panel.__epicCustomTextControlsBound) return;
    panel.__epicCustomTextControlsBound = true;
    var state = panelState(panel);

    var noneRadio = panel.querySelector('[data-epic-text-choice-none]');
    var customRadio = panel.querySelector('[data-epic-text-choice-custom]');
    if (noneRadio) {
      noneRadio.addEventListener('change', function () {
        if (noneRadio.checked) setPersonalized(panel, form, config, false, {});
      });
    }
    if (customRadio) {
      customRadio.addEventListener('change', function () {
        if (customRadio.checked) setPersonalized(panel, form, config, true, {});
      });
    }

    var input = panel.querySelector('[data-epic-text-input]');
    var counter = panel.querySelector('[data-epic-text-counter]');
    var warning = panel.querySelector('[data-epic-text-warning]');
    if (input) {
      var onTextInput = function (event) {
        /*
         * A dead key (Option+E on a Mac) or an IME first inserts a bare
         * accent as composing text; filtering it mid-composition would
         * delete it before the letter lands. Filter when composition ends.
         */
        if (event && event.isComposing) return;
        var result = filteredText(input.value);
        if (result.removed) input.value = result.value;
        state.text = result.value;
        if (counter) counter.textContent = String(result.value.length);
        if (warning) warning.hidden = !result.removed;
        updatePreview(panel);
        updateValidation(panel, form);
      };
      input.addEventListener('input', onTextInput);
      input.addEventListener('compositionend', onTextInput);
    }

    panel.addEventListener('click', function (event) {
      var fontChip = event.target.closest && event.target.closest('[data-epic-text-font]');
      if (fontChip && panel.contains(fontChip)) {
        state.font = fontChip.getAttribute('data-epic-text-font');
        setPressed(panel, '[data-epic-text-font]', 'data-epic-text-font', state.font);
        updatePreview(panel);
        updateValidation(panel, form);
        return;
      }
      var sizeChip = event.target.closest && event.target.closest('[data-epic-text-size]');
      if (sizeChip && panel.contains(sizeChip)) {
        state.size = sizeChip.getAttribute('data-epic-text-size');
        setPressed(panel, '[data-epic-text-size]', 'data-epic-text-size', state.size);
        updatePreview(panel);
        updateValidation(panel, form);
        return;
      }
      var colorSwatch = event.target.closest && event.target.closest('[data-epic-text-color]');
      if (colorSwatch && panel.contains(colorSwatch)) {
        state.color = colorSwatch.getAttribute('data-epic-text-color');
        setPressed(panel, '[data-epic-text-color]', 'data-epic-text-color', state.color);
        updatePreview(panel);
        updateValidation(panel, form);
        return;
      }
      var cornerChoice = event.target.closest && event.target.closest('[data-epic-text-corner-choice]');
      if (cornerChoice && panel.contains(cornerChoice)) {
        setCorner(panel, form, cornerChoice.getAttribute('data-epic-text-corner-choice'));
      }
    });

    var frame = panel.querySelector('[data-epic-text-frame]');
    if (frame) {
      frame.addEventListener('click', function (event) {
        var bounds = frame.getBoundingClientRect();
        if (!bounds.width || !bounds.height) return;
        var vertical = event.clientY - bounds.top < bounds.height / 2 ? 'top' : 'bottom';
        var horizontal = event.clientX - bounds.left < bounds.width / 2 ? 'left' : 'right';
        setCorner(panel, form, vertical + '-' + horizontal);
      });
    }

    var confirm = panel.querySelector('[data-epic-text-confirm]');
    if (confirm) {
      confirm.addEventListener('change', function () {
        updateValidation(panel, form);
      });
    }

    var repaint = function () { updatePreview(panel); };
    window.addEventListener('resize', repaint);
    if (typeof window.ResizeObserver === 'function' && frame) {
      new window.ResizeObserver(repaint).observe(frame);
    }
  }

  function setCorner(panel, form, corner) {
    if (!CORNER_LABELS[corner]) return;
    if (corner === RGB_BLOCKED_CORNER && panel.getAttribute('data-epic-text-rgb') === 'true') return;
    var state = panelState(panel);
    state.corner = corner;
    panel.setAttribute('data-epic-text-corner', corner);
    setPressed(panel, '[data-epic-text-corner-choice]', 'data-epic-text-corner-choice', corner);
    var caption = panel.querySelector('[data-epic-text-corner-caption]');
    if (caption) caption.textContent = CORNER_LABELS[corner];
    updatePreview(panel);
    updateValidation(panel, form);
  }

  /*
   * EMERGENCY OFF (theme-editor "Enable custom text" unticked): the panel
   * never shows, but the catalog's Personalization option may still exist —
   * so keep the native picker hidden and force any selection back to the
   * "None" variant. Without this, a disabled feature (or a republished old
   * theme) would expose a bare "+$7.99" picker with no text field.
   */
  function forceNoneVariant(panel, form, config, optionIndex) {
    var current = findVariantById(config, selectedVariantId(form));
    if (!current) return;
    if (String((current.options || [])[optionIndex]) !== OPTION_VALUE_CUSTOM) return;
    var none = siblingVariant(config, optionIndex, current, OPTION_VALUE_NONE);
    if (none) driveVariant(panel, form, none);
  }

  function enforceDisabledMode(panel, form, config, optionIndex) {
    panel.hidden = true;
    panel.__epicCustomTextOptionIndex = optionIndex;
    hideThemePersonalizationPicker(panel);
    forceNoneVariant(panel, form, config, optionIndex);
    if (!form.__epicCustomTextDisabledBound) {
      form.__epicCustomTextDisabledBound = true;
      form.addEventListener('change', function () {
        window.setTimeout(function () {
          hideThemePersonalizationPicker(panel);
          forceNoneVariant(panel, form, config, optionIndex);
        }, 0);
        window.setTimeout(function () {
          forceNoneVariant(panel, form, config, optionIndex);
        }, 120);
      }, true);
    }
  }

  function initializePanel(panel) {
    if (panel.__epicCustomTextInitialized) return;
    var config = readConfig(panel);
    if (!config || !config.previewUrl) {
      panel.hidden = true;
      return;
    }
    /* Theme-editor section re-renders spawn a fresh panel while the old
       one has already been moved inside the purchase form. Adopt the new
       panel (it carries the fresh settings) and drop stale twins. */
    var twins = document.querySelectorAll(
      '[data-epic-custom-text][data-product-id="' + String(config.productId) + '"]'
    );
    for (var twinIndex = 0; twinIndex < twins.length; twinIndex += 1) {
      if (twins[twinIndex] !== panel && twins[twinIndex].__epicCustomTextInitialized) {
        twins[twinIndex].remove();
      }
    }
    panelState(panel).previewMap = usablePreviewMap(config.previewMap);
    var optionIndex = personalizationOptionIndex(config);
    if (optionIndex === -1 || !hasCustomTextVariant(config, optionIndex)) {
      /* The catalog has not added the Personalization option here yet:
         render nothing and leave the theme untouched. */
      panel.hidden = true;
      return;
    }
    var form = findProductForm(panel);
    if (!form) {
      panel.hidden = true;
      return;
    }
    if (config.enabled === false || panel.hasAttribute('data-epic-text-disabled')) {
      panel.__epicCustomTextInitialized = true;
      enforceDisabledMode(panel, form, config, optionIndex);
      return;
    }

    panel.__epicCustomTextInitialized = true;
    panel.__epicCustomTextOptionIndex = optionIndex;
    panel.__epicCustomTextForms = purchaseFormsFor(panel);
    for (var formIndex = 0; formIndex < panel.__epicCustomTextForms.length; formIndex += 1) {
      panel.__epicCustomTextForms[formIndex].setAttribute(
        'data-epic-custom-text-product-id', String(config.productId)
      );
    }
    form.setAttribute('data-epic-custom-text-product-id', String(config.productId));

    markScope(panel);
    disableExpressCheckout(panel);
    placePanelInForm(panel, form);
    hideThemePersonalizationPicker(panel);
    bindControls(panel, form, config);
    bindVariantChanges(panel, form, config);
    applySelectedVariant(panel, form, config, 'initialize');
    panel.hidden = false;

    /* Symmetry's <variant-picker> hydrates its option pills after this
       init runs, un-hiding (or re-rendering) the Personalization row.
       Re-apply the hide on a short schedule to win the race. */
    var rehide = function () { hideThemePersonalizationPicker(panel); };
    window.setTimeout(rehide, 250);
    window.setTimeout(rehide, 900);
    window.setTimeout(rehide, 2200);
  }

  function guardApproved(panel) {
    if (panel.getAttribute('data-epic-text-personalized') !== 'true') return true;
    return panel.getAttribute('data-epic-text-valid') === 'true' &&
      panel.getAttribute('data-epic-text-confirmed') === 'true';
  }

  function findPanelForForm(form) {
    var scope = form.closest('.product-form, .product__info-container, [data-product-id]');
    var scoped = scope && scope.querySelector('[data-epic-custom-text]');
    if (scoped) return scoped;
    var productId = form.getAttribute('data-epic-custom-text-product-id');
    if (productId) {
      var panels = document.querySelectorAll('[data-epic-custom-text]');
      for (var index = 0; index < panels.length; index += 1) {
        if (panels[index].getAttribute('data-product-id') === productId) return panels[index];
      }
    }
    return null;
  }

  function guardFormEvent(event, form) {
    if (!form || !/\/cart\/add(?:\.js)?(?:\?|$)/.test(form.action || '')) return;
    var panel = findPanelForForm(form);
    if (!panel || guardApproved(panel)) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    var error = panel.querySelector('[data-epic-text-error]');
    if (error) {
      error.textContent = panel.getAttribute('data-epic-text-valid') !== 'true'
        ? 'Finish your custom text (2–20 printable characters) before adding to cart.'
        : 'Please confirm you double-checked your text before adding to cart.';
      error.hidden = false;
    }
    panel.classList.add('epic-custom-text--blocked');
    panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function installGuard() {
    var bootstrap = window.__epicCustomTextBootstrap = window.__epicCustomTextBootstrap || {};
    if (bootstrap.runtimeGuardInstalled) return;
    bootstrap.runtimeGuardInstalled = true;
    document.addEventListener('submit', function (event) {
      guardFormEvent(event, event.target);
    }, true);
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest(
        'form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"]'
      );
      if (button) guardFormEvent(event, button.form);
    }, true);
  }

  function scanPanels() {
    var panels = document.querySelectorAll('[data-epic-custom-text]');
    for (var index = 0; index < panels.length; index += 1) initializePanel(panels[index]);
  }

  installGuard();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanPanels, { once: true });
  } else {
    scanPanels();
  }

  if (typeof window.MutationObserver === 'function') {
    new window.MutationObserver(function (mutations) {
      var needsScan = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          return node.nodeType === 1 && (
            node.matches('[data-epic-custom-text]') ||
            node.matches('.shopify-payment-button, [data-shopify="payment-button"], [data-testid="Checkout-button"]') ||
            node.querySelector('[data-epic-custom-text], .shopify-payment-button, [data-shopify="payment-button"], [data-testid="Checkout-button"]')
          );
        });
      });
      if (needsScan) scanPanels();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.EpicCustomText = Object.freeze({
    GUIDE_VERSION: GUIDE_VERSION,
    FONT_PROFILES: FONT_PROFILES,
    SIZE_MULTIPLIERS: SIZE_MULTIPLIERS,
    parseMatMm: parseMatMm,
    filteredText: filteredText,
    textIsValid: textIsValid
  });
})(window, document);
